
import React from 'react';

import Loading from './Loading';
import Message from './Message';

const ObjectDetail = ({objectDetail, children}) => {
       
    const NotFound = () => {
        return <Message text="Požadované informace nejsou dostupné." />;
    };
    
    if (objectDetail.id === -1) {
        return null;
    }
    
    if (objectDetail.loading) {
        return <Loading/>
    }
    
    if (objectDetail.notFound) {
        return <NotFound/>;
    }
    
    return children;
}

export default ObjectDetail;
